<div class="modal-body  col-sm-12 form-group">
    <form [formGroup]="addFactSheetEvent" (ngSubmit)="onFactSheetSubmit(addFactSheetEvent.value);">
    <div class="card">
        <div class="card-body">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label for="Date" class="form-label">Date <span class="text-danger">*</span></label>
                            <mat-form-field class="fullwidth" appearance="outline">
                                <input matInput [readonly]="!editable" [min]="minDate" formControlName="EventDate" [max]="maxDate" [matDatepicker]="pickerevent" placeholder="Choose a date">
                                <mat-datepicker-toggle matSuffix [for]="pickerevent"></mat-datepicker-toggle>
                                <mat-datepicker #pickerevent></mat-datepicker>
                            </mat-form-field>
                            @if (f.EventDate.touched && f.EventDate.invalid) {
                                <mat-error>
                                    @if (f.EventDate.errors?.['required']) {
                                        <small>Date is required.</small>
                                    }
                                </mat-error>
                            }
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label for="Events" class="form-label">Events <span class="text-danger">*</span></label>
                            <textarea class="form-control" formControlName="eventDescription" rows="2" placeholder="Event Description"></textarea>
                            @if (f.eventDescription.touched && f.eventDescription.invalid) {
                                <div class="text-danger">
                                    @if (f.eventDescription.errors?.['required']) {
                                        <small>Event Description is required.</small>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label for="Attachments1" class="form-label">Attachments1</label>
                            <input type='file' formControlName="browseFiles" (change)="onSelectFile($event)" multiple>
                        </div>
                    </div>
                </div>
        
                <!-- <div class="col-sm-4 height-34">Date*</div>
                <div class="col-sm-5">
                    <mat-form-field class="fullwidth">
                        <input matInput [readonly]="!editable" [min]="minDate" formControlName="EventDate" [max]="maxDate" [matDatepicker]="pickerevent" placeholder="Choose a date">
                        <mat-datepicker-toggle matSuffix [for]="pickerevent"></mat-datepicker-toggle>
                        <mat-datepicker #pickerevent></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-3">&nbsp;</div>
                <div class="col-sm-12">
                    <hr>
                </div>
        
                <div class="col-sm-4 height-34">Events*</div>
                <div class="col-sm-5"><textarea class="form-control" formControlName="eventDescription" rows="2" placeholder="Event Description"></textarea></div>
                <div class="col-sm-3">&nbsp;</div>
                <div class="col-sm-12">
                    <hr>
                </div>
        
                <div class="col-sm-4 height-34">Attachments1</div>
                <div class="col-sm-5" style="padding-top:5px;"><input type='file' formControlName="browseFiles" (change)="onSelectFile($event)" multiple></div>
                <div class="col-sm-3">&nbsp;</div>
                <div class="col-sm-12">
                    <hr>
                </div>
                <div class="col-sm-12">&nbsp;</div> -->
        
                <div class="col-sm-4">&nbsp;</div>
                <div class="col-sm-5">
                    <!-- <input class="btn btn-primary" type="submit" value="Save">
                    <span *ngIf="loading"  class="spinner-border spinner-border" role="status" aria-hidden="true"></span> -->
                    <span class="Err">{{Msg}}</span>
                </div>
                <div class="col-sm-3"><label style="Display:none;" *ngFor='let urldata of fileurls'>{{urldata}}</label></div>
                <!-- <div class="form-group mt-2" style="display:none;">
                    <div class="form-check">
                        <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
                        <label for="autoClose">Auto close alert after three seconds</label>
                    </div>
        
                </div> -->
                <!-- <div class="jumbotron p-4">
                    <div class="container text-center col-sm-4 alertCssforPopup">
                        <app-alert></app-alert>
                        <router-outlet></router-outlet>
                    </div>
                </div> -->
                
            </div>
        </div>
        <div class="d-flex justify-content-center mt-3">
            <button class="btn btn-primary submit-btn small" type="submit">
                Save
                <span *ngIf="loading" class="spinner-border spinner-border" role="status" aria-hidden="true"></span>
            </button>
        </div>
    </form>
</div>
